<template>
    <div class="pa-4">
        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            :search="search"
        >
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Coordinators</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical />
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details />
                    <v-spacer />
                    <v-dialog v-model="dialog" max-width="800px">
                        <template v-slot:activator="{ on, attrs}" v-if="$store.state.currentPagePriv.create">
                            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                                New Coordinator
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="text-h5">{{ formTitle }}</span>
                            </v-card-title>
                            <v-divider />
                            <v-card-text>
                                <v-container>
                                    <v-form ref="form" v-model="valid" lazy-validation>
                                        <v-row>
                                            <v-col cols="12" sm="6" md="6">
                                                <span>Code</span>
                                                <v-text-field maxlength="10" v-model="editedItem.code" filled rounded dense hide-details="auto" @keydown.space.prevent :readonly="editedIndex > -1" :rules="reqRule"> </v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <span>Name</span>
                                                <v-text-field v-model="editedItem.name" filled rounded dense hide-details="auto" :rules="reqRule"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <span>Special</span>
                                                <v-checkbox v-model="editedItem.is_special"></v-checkbox>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <span>Outlet</span>
                                                <v-select :items="outlets" item-text="name" item-value="code" v-model="editedItem.outlet_code" filled rounded dense hide-details ></v-select>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <span>Sort No</span>
                                                <v-text-field type="number" v-model="editedItem.sort_no" filled rounded dense hide-details="auto"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <span>Plus Expired</span>
                                                <v-text-field type="number" v-model="editedItem.plus_expired" filled rounded dense hide-details="auto"></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-container>
                            </v-card-text>
                            <v-divider />
                            <v-card-actions>
                                <v-spacer />
                                <v-btn color="blue darken-1" text @click="close">
                                    Cancel
                                </v-btn>
                                <v-btn color="blue darken-1" text @click="save">
                                    Save
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogDelete" max-width="500px">
                        <v-card>
                            <v-card-title class="body-1 text-center">Anda akan menghapus coordinator ini ?</v-card-title>
                            <v-card-actions>
                                <v-spacer />
                                <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                                <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                <v-spacer />
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogDetail" max-width="800px">
                        <v-card>
                            <v-card-title>
                                <span class="text-h5">Detail Coordinator</span>
                            </v-card-title>
                            <v-divider />
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="6" md="6">
                                            <span class="font-weight-bold">Code</span>
                                            <v-text-field v-model="viewedItem.code" filled rounded dense hide-details="auto" readonly> </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <span class="font-weight-bold">Name</span>
                                            <v-text-field v-model="viewedItem.name" filled rounded dense hide-details="auto" readonly></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <span class="font-weight-bold">Special</span>
                                            <v-chip :color="viewedItem.is_special ? 'green' : 'grey'" small dark class="mt-2">
                                                {{ viewedItem.is_special ? 'Yes' : 'No' }}
                                            </v-chip>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <span class="font-weight-bold">Outlet</span>
                                            <v-text-field :value="getOutletName(viewedItem.outlet_code)" filled rounded dense hide-details="auto" readonly></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <span class="font-weight-bold">Sort No</span>
                                            <v-text-field v-model="viewedItem.sort_no" filled rounded dense hide-details="auto" readonly></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <span class="font-weight-bold">Plus Expired</span>
                                            <v-text-field v-model="viewedItem.plus_expired" filled rounded dense hide-details="auto" readonly></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-divider />
                            <v-card-actions>
                                <v-spacer />
                                <v-btn color="blue darken-1" text @click="closeDetail">
                                    Close
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="viewDetail(item)">
                    mdi-eye
                </v-icon>
                <v-icon small class="mr-2" @click="editItem(item)" v-if="$store.state.currentPagePriv.update">
                    mdi-pencil
                </v-icon> 
                <v-icon small @click="deleteItem(item)" v-if="$store.state.currentPagePriv.delete">
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">
                    Reset
                </v-btn>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    export default {
        data: () => ({
            dialog: false,
            dialogDelete: false,
            dialogDetail: false,
            headers: [
                { text: 'Code', value: 'code' },
                { text: 'Coordinator Name', value: 'name' },
                { text: 'Sort No', value: 'sort_no' },
                { text: 'Plus Expired', value: 'plus_expired' },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            items: [],
            editedIndex: -1,
            editedItem: {},
            defaultItem: {},
            viewedItem: {},
            search: '',
            reqRule: [v => !!v || 'Harus diisi!'],
            valid: true,
            outlets: [],
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'New Coordinator' : 'Edit Coordinator'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
            dialogDetail (val) {
                val || this.closeDetail()
            },
        },

        created() {
            this.initialize();
            this.getOutlets();
        },

        methods: {
            async initialize() {
                let response = await this.$store.dispatch('coordinator/getObjs')
                console.log(response)
                if (response.data.status == 'success') {
                    this.items = response.data.data
                }
            },

            async getOutlets() {
                let response = await this.$store.dispatch('outlet/getObjs');
                if (response.data.status == 'success') {
                    this.outlets = response.data.data;
                }
            },

            viewDetail(item) {
                this.viewedItem = Object.assign({}, item)
                this.dialogDetail = true
            },

            getOutletName(code) {
                if (!code) return '-'
                const outlet = this.outlets.find(o => o.code === code)
                return outlet ? outlet.name : code
            },

            editItem(item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem(item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },

            async deleteItemConfirm() {
                let url = `${this.$store.state.config.apiHost}coordinators/${this.editedItem.code}`
                let response = await this.$axios.delete(url, { headers: { 'Authorization': `Bearer ${this.$store.state.token}`, 'Content-Type': 'application/json' }})
                if (response.data.status == 'success') {
                    this.items.splice(this.editedIndex, 1)
                }
                this.closeDelete()
            },

            close() {
                this.resetForm()
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            closeDelete() {
                this.dialogDelete = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            closeDetail() {
                this.dialogDetail = false
                this.$nextTick(() => {
                    this.viewedItem = {}
                })
            },

            async save() {
                await this.$refs.form.validate();
                if (!this.valid) return;

                if (this.editedIndex > -1) {
                    let url = `${this.$store.state.config.apiHost}coordinators/${this.editedItem.code}`
                    let response = await this.$axios.put(url, JSON.stringify(this.editedItem), {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
                    if (response.data.status == 'success') {
                        Object.assign(this.items[this.editedIndex], this.editedItem)
                    }
                    this.close()
                    this.$store.commit('setSnackbar', {saveSuccess: true, successMessage: 'Data Koordinator berhasil diupdate'})
                } else {
                    try {
                        let dataItem = Object.assign({}, this.editedItem)
                        let url = this.$store.state.config.apiHost + "coordinators"
                        let response = await this.$axios.post(url, JSON.stringify(this.editedItem), { headers: {'Authorization': 'Bearer ' + this.$store.state.token, 'Content-Type': 'application/json'}})
                        if (response.data.status == 'success') {
                            this.items.push(dataItem)
                        }
                        this.close()
                        this.$store.commit('setSnackbar', {saveSuccess: true, successMessage: 'Data Koordinator berhasil ditambahkan'})
                    } catch (err) {
                        const keyword = 'duplicate key'
                        if (err.response.data.message.search(keyword) > -1) {
                            return this.$store.commit('setSnackbar', { saveError: true, errorMessage: "Duplicate Key! Kode sudah terpakai."})
                        } else {
                            return this.$store.commit('setSnackbar', { saveError: true, errorMessage: err.response.data.message})
                        }
                    }
                }
            },
            resetForm() {
                this.$refs.form.reset();
            },
        },

    }
</script>

<style>
.v-text-field fieldset, .v-text-field .v-input__control, .v-text-field .v-input__slot {
    border-radius: 7px!important;
}

</style>